import { Match3 } from './index';

export const match3Modifiers = (Match3: Pick<Match3, 'ruleset'>) => (
  state: Match3.MutableState,
) => ({
  beginNewTurn() {
    state.match3.currentMatchIndex = undefined;
    state.match3.turns.push({
      matches: [],
      rewards: {
        points: 0,
        gems: 0,
      },
    });
  },

  setBlockType(
    { colIndex, rowIndex }: Match3.BoardPosition,
    type: Match3.BlockType,
  ) {
    state.match3.board[colIndex][rowIndex] = type;
  },

  replaceMatches(matches: Match3.BoardPosition[], random: () => number) {
    // Remove matched blocks
    matches
      // Sort the matches so that we splice out blocks from the end first
      .sort((a, b) => b.rowIndex - a.rowIndex)
      .forEach(({ colIndex, rowIndex }) => {
        state.match3.board[colIndex].splice(rowIndex, 1);
      });

    // Push replacement blocks onto the end of the column
    const { rows, replenishmentChance } = Match3.ruleset;
    state.match3.board.forEach((column) => {
      while (column.length < rows) {
        column.push(getReplacementBlock(replenishmentChance, random()));
      }
    });
  },
});

const getReplacementBlock = (
  replenishmentChance: Record<Match3.BlockType, number>,
  roll: number,
) => {
  let spawnRate = 0;
  for (let key in replenishmentChance) {
    spawnRate += replenishmentChance[key];
    if (spawnRate > roll) {
      return key as keyof typeof replenishmentChance;
    }
  }

  // Default to dog in case replenishment chances are incomplete
  console.warn(`Replacement block not found for roll ${roll}`);
  return 'd';
};
